import { type IMetaTotal } from '@/types/IBannerData';
import { type IErrorData } from '@/utils/getErrorData';
import { createSlice } from '@reduxjs/toolkit';
import { getReviewsThunk, updateReviewStatusThunk } from './reviewsThunks';
import { type IReviewFeedbackItem } from '@/types/IReviewFeedback';

export interface IReviewsState {
  reviews: IReviewFeedbackItem[];
  meta: IMetaTotal;
  isLoading: boolean;
  error: IErrorData | null;
}

const initialState: IReviewsState = {
  reviews: [],
  meta: { total: 0 },
  isLoading: false,
  error: null
};

const reviews = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    resetReviews(state) {
      state.reviews = initialState.reviews;
      state.meta = initialState.meta;
      state.isLoading = initialState.isLoading;
      state.error = initialState.error;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReviewsThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getReviewsThunk.fulfilled, (state, action) => {
        state.reviews = action.payload.items;
        state.meta = action.payload.meta;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getReviewsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? {
          message: 'Ошибка при получении отзывов'
        };
      })
      .addCase(updateReviewStatusThunk.fulfilled, (state, action) => {
        const index = state.reviews.findIndex(
          (review) => review.id === action.payload.id
        );
        if (index !== -1) {
          state.reviews[index] = action.payload;
        }
      });
    // TODO: комментарии к отзывам не реализованы на 15.04.2026
    // updateReviewCommentStatusThunk, createReviewCommentThunk, createReviewCommentReplyThunk
  }
});

export const { resetReviews } = reviews.actions;
export default reviews.reducer;
